import React from "react";
import { Media, Texts, Title } from "../../Object";
import { Grid, Space } from "../../Layout";
import Nav from "./Nav";
import { Link } from "react-router-dom";

const Footer = () => {
  const gridProps = {
    main: {
      gap: ['80px'],
      size: ['100%'],
      layout: ['repeat(2, 1fr)', '100%'],
    }
  }

  return (
    <>
      <div className="l-footer__wrap">
        <FixContact />
        <div className="l-row">
          <Grid {...gridProps.main}>
            <LeftElm />
            <RightElm />
          </Grid>
        </div>
      </div>
    </>
  );
};

const RightElm = () => {
  const googleMap = `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3276.654061670768!2d135.20970897719192!3d34.78948317844156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600089ef71353957%3A0x8bf874bcd6902850!2z44CSNjUxLTEzMzIg5YW15bqr55yM56We5oi45biC5YyX5Yy65ZSQ5quD5Y-w77yS5LiB55uu77yW4oiS77yS77yT!5e0!3m2!1sja!2sjp!4v1683308824684!5m2!1sja!2sjp" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;
  const gridProps = {
    main: {
      gap: ['16px'],
      layout: ['100%'],
    }
  }
  return (
    <>
      <Grid {...gridProps.main}>
        <div className="l-footer__map" dangerouslySetInnerHTML={{__html: googleMap}}></div>
        <Texts class="c-text--white" slug="footer/address"></Texts>
      </Grid>
    </>
  )
}

const FixContact = () => {
  return (
    <div className="l-footer__wrap--fix">
      <Link to="tel:0789874877">
        <Media src="common/fix-call" class="l-footer__wrap--fix__media" alt="078-987-4877"></Media>
      </Link>
      <Link to="/contact">
        <Media state="mail" src="common/fix-mail" class="l-footer__wrap--fix__media" alt="お問い合わせフォーム"></Media>
      </Link>
    </div>
  );
};

const LeftElm = () => {
  const gridProps = {
    main: {
      gap: ['64px', '48px'],
      size: ['100%'],
      layout: ['100%'],
      dir: ['row']
    },
    logo: {
      size: ['122px'],
      layout: ['122px'],
    }
  }
  return (
    <>
      <Grid {...gridProps.main}>
        <Grid {...gridProps.logo}>
          <Link to="/">
            <Media class="l-footer__img--logo" src="common/icon-logo-white" alt="logo"></Media>
          </Link>
        </Grid>
        <Nav remove={[""]} position="footer"/>
      </Grid>
    </>
  );
};

export default Footer;
